"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const react_redux_1 = require("react-redux");
const classnames_1 = __importDefault(require("classnames"));
const Chip_1 = __importDefault(require("@mui/material/Chip"));
const Avatar_1 = __importDefault(require("@mui/material/Avatar"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const MoreVert_1 = __importDefault(require("@mui/icons-material/MoreVert"));
const Popover_1 = __importDefault(require("@mui/material/Popover"));
const List_1 = __importDefault(require("@mui/material/List"));
const ListItem_1 = __importDefault(require("@mui/material/ListItem"));
const ListItemButton_1 = __importDefault(require("@mui/material/ListItemButton"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const rootUiActions_1 = require("companion-app-components/flux/root-ui/rootUiActions");
const dataset_shares_1 = require("companion-app-components/flux/dataset-shares");
const core_1 = require("companion-app-components/utils/core");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const auth_1 = require("companion-app-components/flux/auth");
const utils_1 = require("containers/ProfilePage/utils");
const utils_2 = require("./utils");
const styles_1 = require("./styles");
const actions_1 = require("../actions");
const useStyles = (0, mui_1.makeStyles)()(styles_1.userListStyles);
const UserList = ({ ownerName, ownerEmail, share, datasetName = '', manager = false, canManageSharePermissions = false, }) => {
    var _a;
    const { granteeFirstName, granteeLastName, granteeEmail, lastInviteSent, state = '' } = share || {};
    const name = ownerName || `${granteeFirstName === null || granteeFirstName === void 0 ? void 0 : granteeFirstName.trim()} ${granteeLastName === null || granteeLastName === void 0 ? void 0 : granteeLastName.trim()}`;
    const currentDatasetId = (0, react_redux_1.useSelector)(auth_1.authSelectors.getDatasetId);
    const accountGroups = (_a = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.getAccountGroups)) !== null && _a !== void 0 ? _a : [];
    const canShowPermissionEditor = (0, utils_2.canShowChangePermissionOption)(canManageSharePermissions, accountGroups.length > 0, currentDatasetId === (share === null || share === void 0 ? void 0 : share.datasetId), state);
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const dispatch = (0, react_redux_1.useDispatch)();
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleRemove = () => {
        dispatch(dataset_shares_1.datasetSharesActions.deleteDatasetShare(share));
    };
    const handleRevoke = () => {
        dispatch((0, rootUiActions_1.removeDialog)(actions_1.DIALOG_TYPE_CONFIRMATION_NEW));
        handleRemove();
    };
    const handleResend = () => {
        const shareUpdated = share === null || share === void 0 ? void 0 : share.set('state', dataset_shares_1.datasetSharesTypes.DATASET_SHARING_STATES.INVITED);
        dispatch(dataset_shares_1.datasetSharesActions.updateDatasetShare(shareUpdated));
    };
    const getInviteState = (shareState, date) => {
        let label = 'Full Access';
        let color = 'text.tertiary';
        if (shareState === dataset_shares_1.datasetSharesTypes.DATASET_SHARING_STATES.INVITED && (0, utils_1.checkIfInviteExpired)(date)) {
            label = 'Invitation Expired';
            color = 'number.negative';
        }
        else if (shareState === dataset_shares_1.datasetSharesTypes.DATASET_SHARING_STATES.INVITED) {
            label = shareState;
        }
        else if (shareState === dataset_shares_1.datasetSharesTypes.DATASET_SHARING_STATES.ABANDONED) {
            label = 'No longer shared';
        }
        else if (shareState === dataset_shares_1.datasetSharesTypes.DATASET_SHARING_STATES.ACTIVE && !(0, utils_2.hasDatasetFullAccess)(accountGroups, share)) {
            label = 'Custom Access';
        }
        return { label, color };
    };
    const handleMember = (action, eventName) => {
        handleClose();
        if (action === 'resend') {
            handleResend();
            core_1.tracker.track(core_1.tracker.events.datasetSharing, { property: 'manageAccess', action: eventName });
        }
        else if (action === 'revoke') {
            dispatch((0, actions_1.showConfirmationDialog)({
                heading: 'Revoke Invitation',
                subHead: `Revoking ${name}’s invitation?`,
                description: `Please note, this member will no longer be able to accept your invitation to “${datasetName}”`,
                buttons: [
                    {
                        label: 'CANCEL',
                        variant: 'outlined',
                        action: () => dispatch((0, rootUiActions_1.removeDialog)(actions_1.DIALOG_TYPE_CONFIRMATION_NEW)),
                    },
                    {
                        label: 'REVOKE',
                        variant: 'outlined',
                        action: () => {
                            handleRevoke();
                            dispatch((0, rootUiActions_1.removeDialog)(actions_1.DIALOG_TYPE_CONFIRMATION_NEW));
                            core_1.tracker.track(core_1.tracker.events.datasetSharing, { property: 'manageAccess', action: eventName });
                        },
                    },
                ],
            }));
        }
        else if (action === 'remove') {
            dispatch((0, actions_1.showConfirmationDialog)({
                heading: 'Remove',
                subHead: `Remove ${name}?`,
                description: `Please note, this member will no longer be able to access to “${datasetName}”`,
                buttons: [
                    {
                        label: 'CANCEL',
                        variant: 'outlined',
                        action: () => dispatch((0, rootUiActions_1.removeDialog)(actions_1.DIALOG_TYPE_CONFIRMATION_NEW)),
                    },
                    {
                        label: 'REMOVE',
                        variant: 'outlined',
                        action: () => {
                            handleRemove();
                            dispatch((0, rootUiActions_1.removeDialog)(actions_1.DIALOG_TYPE_CONFIRMATION_NEW));
                            core_1.tracker.track(core_1.tracker.events.datasetSharing, { property: 'manageAccess', action: eventName });
                        },
                    },
                ],
            }));
        }
        else if (action === 'showAccountGroups') {
            dispatch((0, actions_1.showAccountShareDialog)({ share }));
        }
    };
    const { classes } = useStyles();
    return (<div className={classes.wrapper}>
      <Avatar_1.default {...(0, utils_2.stringAvatar)(name)}/>
      <div className={classes.labelsWrapper}>
        <Typography_1.default variant="subtitle1" className={(0, classnames_1.default)(classes.nameWrapper, classes.textEllipsis)}>
          {name}
        </Typography_1.default>
        <Typography_1.default variant="body2" className={(0, classnames_1.default)(classes.textTertiary, classes.textEllipsis)}>
          {ownerEmail || granteeEmail}
        </Typography_1.default>
      </div>
      <div className={classes.rightBlock}>
        {manager &&
            <Typography_1.default variant="body2" className={(0, classnames_1.default)(classes.textTertiary, classes.managerBlock)}>
            Owner
          </Typography_1.default>}
        {!manager &&
            <>
            <Chip_1.default label={(0, utils_2.capitalizeString)(getInviteState(state, lastInviteSent).label)} className={classes.chip} sx={{ color: getInviteState(state, lastInviteSent).color }}/>
            <IconButton_1.default onClick={handleClick}>
              <MoreVert_1.default fontSize="small"/>
            </IconButton_1.default>
            <Popover_1.default open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}>
              <List_1.default>
                {utils_2.membersOptions.filter((option) => option.types.includes(state)).map((option) => (<ListItem_1.default key={option.action} disablePadding onClick={() => handleMember(option.action, option.eventName)}>
                    <ListItemButton_1.default>
                      <ListItemText_1.default primary={option.label}/>
                    </ListItemButton_1.default>
                  </ListItem_1.default>))}
                {canShowPermissionEditor && (<ListItem_1.default disablePadding onClick={() => handleMember('showAccountGroups', '')}>
                    <ListItemButton_1.default>
                      <ListItemText_1.default primary={'Change Permission'}/>
                    </ListItemButton_1.default>
                  </ListItem_1.default>)}
              </List_1.default>
            </Popover_1.default>
          </>}
      </div>
    </div>);
};
exports.default = UserList;
